import Dropdown from "../Dropdown";
import Descreption from "../Descreption"; /* .. means one step back in folder and . means in the current folder*/
import Content from "../Content";
import Signup from "../Signup";
import Footer from "../Footer";
import Navbar from "../Navbar";

export default function HomePage(){
    return(
<div>
    <Navbar />
  <div data-aos="fade-up" data-aos-delay="0">
        <Descreption />
    </div>

    <div data-aos="fade-up" data-aos-delay="100">
        <Dropdown />
    </div>

    <div data-aos="fade-up" data-aos-delay="200">
        <Content />
    </div>

    <div data-aos="fade-up" data-aos-delay="300">
        <Signup />
    </div>
       <Footer />

</div>

    )


}